export const getQueryParamFromUrlByKey = (url, key) => {
  key = key.replace(/[\[]/, "\\[").replace(/[\]]/, "\\]");
  const regex = new RegExp("[\\?&]" + key + "=([^&#]*)");
  const results = regex.exec(url);
  return results === null
    ? null
    : decodeURIComponent(results[1].replace(/\+/g, " "));
};
